import { ViteReactSSG } from 'vite-react-ssg'
import { routes } from './routes'
import './index.css'

// Static-site-generation entry. vite-react-ssg pre-renders every route to HTML
// at build time, then hydrates on the client.
export const createRoot = ViteReactSSG({ routes })
